/** Roulette bet types — matches backend `CasinoGame` allowed outcomes. */
export const ROULETTE_OUTCOME_TYPES = [
  "ExactNumber",
  "Red",
  "Black",
  "Green",
  "Odd",
  "Even",
  "sector_1_6",
  "sector_7_12",
  "sector_13_18",
  "sector_19_24",
  "sector_25_30",
  "sector_31_36",
  "group_1_12",
  "group_13_25",
  "group_26_36",
];

export const SUGGESTED_MULTIPLIERS = {
  ExactNumber: 35,
  Red: 2,
  Black: 2,
  Green: 14,
  Odd: 2,
  Even: 2,
  sector_1_6: 6,
  sector_7_12: 6,
  sector_13_18: 6,
  sector_19_24: 6,
  sector_25_30: 6,
  sector_31_36: 6,
  group_1_12: 3,
  group_13_25: 3,
  group_26_36: 3,
};

export const OUTCOME_GROUPS = [
  {
    id: "colors",
    label: "Colors",
    outcomes: ["Red", "Black", "Green"],
  },
  {
    id: "parity",
    label: "Odd / Even",
    outcomes: ["Odd", "Even"],
  },
  {
    id: "sectors",
    label: "Sectors",
    outcomes: [
      "sector_1_6",
      "sector_7_12",
      "sector_13_18",
      "sector_19_24",
      "sector_25_30",
      "sector_31_36",
    ],
  },
  {
    id: "columns",
    label: "Columns",
    outcomes: ["group_1_12", "group_13_25", "group_26_36"],
  },
  {
    id: "special",
    label: "Special",
    outcomes: ["ExactNumber"],
  },
];

export const OUTCOME_COLORS = {
  Red: "#C62828",
  Black: "#1A1A1A",
  Green: "#2E7D32",
  Odd: "#64B5F6",
  Even: "#42A5F5",
  ExactNumber: "#1E88E5",
};

export const OUTCOME_PRESETS = [
  {
    id: "colors",
    label: "Classic colors",
    hint: "Red, Black, Green",
    outcomes: ["Red", "Black", "Green"],
  },
  {
    id: "colors-parity",
    label: "Colors + parity",
    hint: "Adds Odd & Even",
    outcomes: ["Red", "Black", "Green", "Odd", "Even"],
  },
  {
    id: "full",
    label: "Full table",
    hint: "All bet types",
    outcomes: ROULETTE_OUTCOME_TYPES,
  },
];

export const MIN_CASINO_ALLOCATION = 5000;

export function formatOutcomeLabel(outcomeType) {
  if (!outcomeType) return "";
  return outcomeType
    .replace(/_/g, " ")
    .replace(/\bsector\b/i, "Sec")
    .replace(/\bgroup\b/i, "Col");
}

export function buildPresetOutcomes(outcomeTypes) {
  return outcomeTypes.map((outcomeType) => ({
    outcomeType,
    multiplier: String(SUGGESTED_MULTIPLIERS[outcomeType] ?? 2),
  }));
}
